import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import styles from './Hashtag.module.scss';
import ModuleNewsletter from "./ModuleNewsletter";
import {PAGE_DESCRIPTION_GENERAL, PAGE_TITLE_GENERAL} from "../utils/constants";

class Hashtag extends Component {
    componentDidMount() {
        setTimeout(function () {
            document.querySelector(".loader-wrapper").style = "display: none";
        }, 2000);
    }

    render() {
        return (
            <React.Fragment>
                <Helmet>
                    <title>{PAGE_TITLE_GENERAL}</title>
                    <meta name="description"
                          content={PAGE_DESCRIPTION_GENERAL}/>
                </Helmet>

                <section className={styles.hashtagSection}>
                    <h2>#ootdHAMMER</h2>
                    <p>
                        Share your personal style and see how others are styling their favourites from Hammer.<br/>Tag
                        your picture with @hammerbrandofficial and #ootdHAMMER for a chance to be featured on hammer-clothing.com
                        and in our stores.
                    </p>
                    <div className={styles.hashtagPhotos}>
                        <div className={styles.hashtagPhoto}>
                            <a href="https://www.instagram.com/hammerbrandofficial/" target="_blank" rel="noopener noreferrer">
                                <img src={`${process.env.PUBLIC_URL}/assets/images/wm/hm/hashtag/hashtag01.jpeg`}
                                     alt="HashTag"/>
                                <div className={styles.hashtagPhotoOverlay}>
                                    <div className={styles.hashtagPhotoText}>
                                        @hammerbrandofficial
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div className={styles.hashtagPhoto}>
                            <a href="https://www.instagram.com/hammerbrandofficial/" target="_blank" rel="noopener noreferrer">
                                <img src={`${process.env.PUBLIC_URL}/assets/images/wm/hm/hashtag/hashtag09.jpeg`}
                                     alt="HashTag"/>
                                <div className={styles.hashtagPhotoOverlay}>
                                    <div className={styles.hashtagPhotoText}>
                                        @hammerbrandofficial
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div className={styles.hashtagPhoto}>
                            <a href="https://www.instagram.com/hammerbrandofficial/" target="_blank" rel="noopener noreferrer">
                                <img src={`${process.env.PUBLIC_URL}/assets/images/wm/hm/hashtag/hashtag06.jpeg`}
                                     alt="HashTag"/>
                                <div className={styles.hashtagPhotoOverlay}>
                                    <div className={styles.hashtagPhotoText}>
                                        @hammerbrandofficial
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div className={styles.hashtagPhoto}>
                            <a href="https://www.instagram.com/hammerbrandofficial/" target="_blank" rel="noopener noreferrer">
                                <img src={`${process.env.PUBLIC_URL}/assets/images/wm/hm/hashtag/hashtag04.jpeg`}
                                     alt="HashTag"/>
                                <div className={styles.hashtagPhotoOverlay}>
                                    <div className={styles.hashtagPhotoText}>
                                        @hammerbrandofficial
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div className={styles.hashtagPhoto}>
                            <a href="https://www.instagram.com/hammerbrandofficial/" target="_blank" rel="noopener noreferrer">
                                <img src={`${process.env.PUBLIC_URL}/assets/images/wm/hm/hashtag/hashtag02.jpeg`}
                                     alt="HashTag"/>
                                <div className={styles.hashtagPhotoOverlay}>
                                    <div className={styles.hashtagPhotoText}>
                                        @hammerbrandofficial
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div className={styles.hashtagPhoto}>
                            <a href="https://www.instagram.com/hammerbrandofficial/" target="_blank" rel="noopener noreferrer">
                                <img src={`${process.env.PUBLIC_URL}/assets/images/wm/hm/hashtag/hashtag03.jpeg`}
                                     alt="HashTag"/>
                                <div className={styles.hashtagPhotoOverlay}>
                                    <div className={styles.hashtagPhotoText}>
                                        @hammerbrandofficial
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div className={styles.hashtagPhoto}>
                            <a href="https://www.instagram.com/hammerbrandofficial/" target="_blank" rel="noopener noreferrer">
                                <img src={`${process.env.PUBLIC_URL}/assets/images/wm/hm/hashtag/hashtag07.jpeg`}
                                     alt="HashTag"/>
                                <div className={styles.hashtagPhotoOverlay}>
                                    <div className={styles.hashtagPhotoText}>
                                        @hammerbrandofficial
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div className={styles.hashtagPhoto}>
                            <a href="https://www.instagram.com/hammerbrandofficial/" target="_blank" rel="noopener noreferrer">
                                <img src={`${process.env.PUBLIC_URL}/assets/images/wm/hm/hashtag/hashtag08.jpeg`}
                                     alt="HashTag"/>
                                <div className={styles.hashtagPhotoOverlay}>
                                    <div className={styles.hashtagPhotoText}>
                                        @hammerbrandofficial
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div className={styles.hashtagPhoto}>
                            <a href="https://www.instagram.com/hammerbrandofficial/" target="_blank" rel="noopener noreferrer">
                                <img src={`${process.env.PUBLIC_URL}/assets/images/wm/hm/hashtag/hashtag05.jpeg`}
                                     alt="HashTag"/>
                                <div className={styles.hashtagPhotoOverlay}>
                                    <div className={styles.hashtagPhotoText}>
                                        @hammerbrandofficial
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </section>

                <ModuleNewsletter />

            </React.Fragment>
        );
    }
}

export default Hashtag;